import React from 'react'
import logo from '../../images/logo.png'

function Header() {
  return (
    <header className='center'>
        <img src={logo} alt="" />
    </header>
  )
}

export default Header